import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aa54ee94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col fst-italic" }
const _hoisted_3 = { class: "row mt-3 mb-1" }
const _hoisted_4 = {
  class: "col-auto",
  style: {"min-height":"40px"}
}
const _hoisted_5 = {
  key: 0,
  class: "row"
}
const _hoisted_6 = { class: "col text-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-secondary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" })
], -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "row justify-content-center" }
const _hoisted_11 = {
  key: 0,
  class: "col-auto text-center"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "alert alert-info",
  role: "alert"
}, " Der blev ikke fundet nogle filer i biblioteket. ", -1))
const _hoisted_13 = {
  key: 1,
  class: "row"
}
const _hoisted_14 = { class: "col" }
const _hoisted_15 = {
  key: 2,
  class: "row"
}
const _hoisted_16 = { class: "col" }
const _hoisted_17 = {
  controls: "",
  class: "img-fluid"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 3,
  class: "row"
}
const _hoisted_20 = { class: "col" }
const _hoisted_21 = { class: "table table-borderless" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]

import { API } from '@/helpers/API';
    import { ref, computed } from 'vue';
    import VuePdfApp from "vue3-pdf-app";
    import "vue3-pdf-app/dist/icons/main.css";
    import { encode } from 'js-base64';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

    const library = ref<String[]>([]);
    const currentPath = ref('/');
    const loading = ref(true);
    const retry = ref(0);

    const pdfBuffer = ref(null);
    const videoBuffer = ref(null);

    const apiUrl = process.env.VUE_APP_API_BASE_URL;

    const allowedFileTypes = [
        'pdf',
        'doc',
        'docx',
        'xls',
        'xlsx',
        'ppt',
        'pptx',
        'mp4'
    ];

    const fileIcons = {
        'pdf': 'b-icon-file-earmark-pdf',
        'doc': 'b-icon-file-earmark-word',
        'docx': 'b-icon-file-earmark-word',
        'xls': 'b-icon-file-earmark-excel',
        'xlsx': 'b-icon-file-earmark-excel',
        'ppt': 'b-icon-file-earmark-ppt',
        'pptx': 'b-icon-file-earmark-ppt',
        'mp4': 'b-icon-file-earmark-play'
        
    }

    const fileIconColors = {
        'pdf': 'text-danger',
        'doc': 'text-primary',
        'docx': 'text-primary',
        'xls': 'text-success',
        'xlsx': 'text-success',
        'ppt': 'text-warning',
        'pptx': 'text-warning',
        'mp4': 'text-primary'
    }

    const folders = computed(() => {
        return library.value.filter((item: string) => {
            const regex = new RegExp('^' + currentPath.value + '[^\/.]+$');
            return item.match(regex);
        })
    });


    const files = computed(() => {
        return library.value.filter((item: string) => {
            const regex = new RegExp('^' + currentPath.value + '[^\\/]+\\.([a-zA-Z0-9]{0,4})$');
            const match = item.match(regex)
            if (!match || match === null || !allowedFileTypes.includes(match[1]))
            {
                return false;
            }
            return true;

        })
    });

    const goToFolder = (path: string) => {
        currentPath.value = path + '/';
    }

    const goBack = () => {
        if (pdfBuffer.value !== null) {
            currentPath.value += '/';
        }
        pdfBuffer.value = null;
        videoBuffer.value = null;
        currentPath.value = currentPath.value.replace(/\/[^\/]+\/$/, '/');
    }

    const showFile = (path: string) => {
        const type = fileType(path);
        if (type == 'pdf') {
            showPDF(path);
            return;
        }

        if (type == 'mp4') {
            videoBuffer.value = 'service-app/file/' + encode(path);
            console.log('service-app/file/' + encode(path))
            return;
        }

        downloadFile(path);
        return;
    }

    const downloadFile = (path: string) => {
        const fileConfig = {
            url: 'service-app/file/' + encode(path),
            method: 'get',
            params: {},
            responseType: 'arraybuffer'
        }

        let contentType = '';
        var fileName = path.substring(path.lastIndexOf('/') + 1);
        loading.value = true;

        API.request(fileConfig)
        .then((response: any) => {
            const blob = new Blob( [ response.data ], { type: response.headers['content-type'] } );	
            const link = document.createElement( 'a' );
            link.href = URL.createObjectURL( blob );
            link.download =  fileName;
            link.click();
        })
        .catch((error: any) => {
            console.error(error);
        })
        .finally(() => {
            loading.value = false;
        })
    }

    const showPDF = (path: string) => {
        loading.value = true;
        currentPath.value = path
        const pdfConfig = {
            url: 'service-app/file/' + encode(path),
            method: 'get',
            params: {},
            responseType: 'arraybuffer'
        }
        API.request(pdfConfig)
        .then((response: any) => {
            
            pdfBuffer.value = response.data;
        })
        .catch((error: any) => {
            console.error(error);
        })
        .finally(() => {
            loading.value = false;
        })
    }

    const fileType = (path: string) => {
        const fileType = path?.match(/\.([a-zA-Z0-9]{0,4})$/);
        if (fileType && fileType !== null && allowedFileTypes.includes(fileType[1])) {
            return fileType[1];
        }

        return null;
    }

    const getIcons = (path: string): string => {
        const type = fileType(path);
        if (type !== null && allowedFileTypes.includes(type)) {
            return fileIcons[type as keyof object];
        }

        return 'b-icon-file-earmark'
    }

    const getColor = (path: string) => {
        const type = fileType(path);
        if (type !== null && allowedFileTypes.includes(type)) {
            return fileIconColors[type as keyof object];
        }

        return 'text-black';
    }

    const name = (path: string) => {
        return path.replace(currentPath.value, '');
    }

    const getList = async () => {
        const config = {
            url: 'service-app/files/list',
            method: 'get',
            params: {}
        }
        loading.value = true;
        API.request(config).then((response: any) => {
            library.value = response.data;
            currentPath.value = '/';
        })
        .catch((error: any) => {
            console.error(error);
        })
        .finally(() => {
            if (library.value.length < 1 && retry.value < 4) {
                setTimeout(() => {
                    retry.value++;
                    getList();
                }, 1500);
            } else {
                retry.value = 0;
                loading.value = false;
            }
        })
    }

    getList();
    

return (_ctx: any,_cache: any) => {
  const _component_b_icon_arrow_left = _resolveComponent("b-icon-arrow-left")!
  const _component_b_icon_folder = _resolveComponent("b-icon-folder")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(currentPath.value), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (currentPath.value !== '/' || pdfBuffer.value !== null || videoBuffer.value !== null)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-link btm-sm",
              onClick: goBack
            }, [
              _createVNode(_component_b_icon_arrow_left, { class: "fs-1" }),
              _createTextVNode(" Tilbage")
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            (retry.value == 1 || retry.value == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Appen prøver stadig at hente filerne."))
              : _createCommentVNode("", true),
            (retry.value == 3 || retry.value == 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Det tager lidt længere tid end normalt."))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      (!loading.value && library.value.length < 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-warning",
                onClick: getList
              }, "Prøv igen")
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (pdfBuffer.value !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_unref(VuePdfApp), {
              style: {"height":"100vh"},
              pdf: pdfBuffer.value
            }, null, 8, ["pdf"])
          ])
        ]))
      : (videoBuffer.value !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("video", _hoisted_17, [
                _createElementVNode("source", {
                  src: _unref(apiUrl)+'/api/v1/'+videoBuffer.value,
                  type: "video/mp4"
                }, null, 8, _hoisted_18),
                _createTextVNode(" Din browser understøtter ikke videoen. ")
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("table", _hoisted_21, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(folders), (path, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: "border-top pointer",
                      onClick: ($event: any) => (goToFolder(path))
                    }, [
                      _createElementVNode("td", null, [
                        _createVNode(_component_b_icon_folder, { class: "fs-2 text-warning" })
                      ]),
                      _createElementVNode("td", null, _toDisplayString(name(path)), 1)
                    ], 8, _hoisted_22))
                  }), 128))
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(files), (path, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: "border-top pointer",
                      onClick: ($event: any) => (showFile(path))
                    }, [
                      _createElementVNode("td", null, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(getIcons(path)), {
                          class: _normalizeClass(["fs-2", getColor(path)])
                        }, null, 8, ["class"]))
                      ]),
                      _createElementVNode("td", null, _toDisplayString(name(path)), 1)
                    ], 8, _hoisted_23))
                  }), 128))
                ])
              ])
            ])
          ]))
  ], 64))
}
}

})